/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-22 14:26:05
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-02-29 11:12:30
 */
export const tzRouter = [
	'/index',
	'/index/home',
	'/teamManage',
	'/teamManage/subAccount',
	'/teamManage/achievements',
	'/shopManage',
	'/shopManage/pallet',
	'/shopManage/shopLibrary',
	'/shopManage/shopGroup',
	'/shopManage/shopGroup/group',
	'/shopManage/shopGroup/record',
	'/shopManage/shopGroup/detail',
	'/shopGroup/detail/list',
	'/shopGroup/detail/shopDetails',
	'/talentCRM',
	'/talentCRM/clueSeas',
	'/talentCRM/myTalent',
	'/cooperationProgress',
	'/cooperationProgress/list',
	'/cooperationProgress/details',
	'/shopManage/shopLibrary/list',
	'/shopManage/shopLibrary/shopLibraryDetails',
	'/shopLibrary/record',
	'/extenTecord',
	'/shopManage/extenTecord/list',
	'/shopManage/extenTecord/details',
	'/shopManage/extenTecord/details/list',
	'/shopManage/extenTecord/details/shopDetails',
	'/tagManagement',
	'/shopManage/tagManagement/list',
	'/shopManage/tobeClaime',
	'/shopManage/tobeClaime/list',
	'/shopManage/tobeClaime/detail',
	'/trusteeship',
	'/shopManage/trusteeship/list',
	'/shopManage/trusteeship/detail',
	'/sample',
	'/sample/list',
	'/sample/importLog',
	'/order',
	'/order/list',
	'/order/record',
	'/cooperationProgress/record',
	'/order/updateLog',
	'/shopLibrary/waste',
	'/personal',
	'/personal/center',
	'/talentCRM/emphasisTalent',
	'/talentCRM/contacts',
	'/talentCRM/ruleManage',
	'/talentCRM/ruleManage/list',
	'/talentCRM/ruleManage/ruleSet',
	'/talentCRM/groupSeas',
	'/talentCRM/groupSeas/importLog',
	'/talentCRM/record',
	'/talentCRM/allocatedrecord',
	'/secondColonelManage',
	'/secondColonelManage/releasePlatform',
	'/secondColonelManage/colonelActivitySquare',
	'/secondColonelManage/colonelActivitySquare/list',
	'/secondColonelManage/colonelActivitySquare/detail',
	'/secondColonelManage/myActivities',
	'/secondColonelManage/myActivities/list',
	'/secondColonelManage/myActivities/detail',
	'/secondColonelManage/cooperativeColonel',
	'/secondColonelManage/cooperativeColonel/list',
	'/secondColonelManage/cooperativeColonel/detail',
	'/ranking',
	'/ranking/issueTalent',
	'/ranking/issueProduct',
	'/ranking/issueHeader',
	'/ranking/record',
	'/teamManage/groupConf',
	'/selectionDecoration',
	'/selectionDecoration/list',
	'/cooperativeShop',
	'/cooperativeShop/list',
	'/cooperativeShop/collaborateRules',
	'/cooperativeShop/collaborateRules/viewRules',
	'/cooperativeShop/collaborateRules/editRules',
	'/libray',
	'/libray/local/list'

];
